'use client';
import DropdownFilter, { FiltersType } from 'components/common/DropdownFilter';
import MinthrDateRangePicker from 'components/common/MinthrDateRangePicker';
import MinthrSlider from 'components/common/MinthrSlider';
import { GetTypeCongeService } from 'features/conge/services/leaveService';
import { DemandeType } from 'features/conge/types/leaveRequestType';
import useFetchData from 'hooks/useFetch';
import { t } from 'i18next';
import moment, { Moment } from 'moment';
import React, { useState, Dispatch, SetStateAction } from 'react';
import { getSites, getSocieties, getTeams } from 'services/filtersService';
interface LeaveRequestFilterProps {
  setFilters: React.Dispatch<React.SetStateAction<DemandeType>> | undefined;
  setHasFilter: Dispatch<SetStateAction<boolean>>;
  className: string;
}
interface tempFilters {
  filters: {
    status: number[];
    TypeConge: number[];
    society: number[];
    site: number[];
    team: number[];
  };
}

interface tempRangeFilters {
  filters: {
    range_min?: number | null;
    range_max?: number | null;
  };
}

const LeaveRequestFilter: React.FC<LeaveRequestFilterProps> = ({
  setFilters,
  setHasFilter,
  className,
}) => {
  const { data: typeCongeList } = useFetchData(GetTypeCongeService, []);
  const { data: societies } = useFetchData(getSocieties, []);
  const { data: sites } = useFetchData(getSites, []);
  const { data: teams } = useFetchData(getTeams, []);

  const [selectedPeriod, setSelectedPeriod] = useState<Moment[] | null>();
  const [createdRange, setCreatedRange] = useState<Moment[] | null>();
  const [tempFilters, setTempFilters] = useState<tempFilters>({
    filters: {
      status: [],
      TypeConge: [],
      society: [],
      site: [],
      team: [],
    },
  });
  const [tempRangeFilters, settempRangeFilters] = useState<tempRangeFilters>({
    filters: {
      range_min: null,
      range_max: null,
    },
  });
  const statusOptions = [
    { id: 0, title: t('En_Cour') },
    { id: 1, title: t('Accepter') },
    { id: 2, title: t('Annuler') },
    { id: 3, title: t('Refuser') },
    { id: 4, title: t('Holiday_Canceled') },
  ];

  const handleApply = (): void => {
    if (setFilters) {
      setFilters((prevState) => ({
        ...prevState,
        filters: {
          ...prevState.filters,
          date_created_min: createdRange
            ? createdRange[0].format('YYYY-MM-DD')
            : null,
          date_created_max: createdRange
            ? createdRange[1].format('YYYY-MM-DD')
            : null,
          typeCongeIds: tempFilters.filters.TypeConge,
          status: tempFilters.filters.status,
          dateMin: selectedPeriod
            ? selectedPeriod[0].format('YYYY-MM-DD')
            : null,
          dateMax: selectedPeriod
            ? selectedPeriod[1].format('YYYY-MM-DD')
            : null,
          site:
            tempFilters.filters.site?.length > 0
              ? (tempFilters.filters.site?.join(',') ?? null)
              : null,
          society:
            tempFilters.filters.society?.length > 0
              ? (tempFilters.filters.society?.join(',') ?? null)
              : null,
          teams:
            tempFilters.filters.team?.length > 0
              ? (tempFilters.filters.team?.join(',') ?? null)
              : null,
          range_min: tempRangeFilters.filters.range_min ?? null,
          range_max: tempRangeFilters.filters.range_max ?? null,
        },
      }));
    }

    setHasFilter(
      Object.values(tempFilters.filters).some((value) =>
        Array.isArray(value) ? value.length > 0 : false,
      ) || (createdRange ? true : false),
    );
  };

  const handleResetFilters = (): void => {
    if (setFilters) {
      setFilters((prevState) => ({
        ...prevState,
        filters: {
          ...prevState.filters,
          date_created_min: null,
          date_created_max: null,
          typeCongeIds: [],
          status: [],
          society: null,
          site: null,
          teams: null,
          range_min: null,
          range_max: null,
          approval: null,
        },
      }));
    }
    setCreatedRange(null);
    setCreatedRange(null);
    setTempFilters({
      filters: {
        status: [],
        TypeConge: [],
        society: [],
        site: [],
        team: [],
        approval: null,
      },
    });
    setHasFilter(
      Object.values(tempFilters.filters).some((value) =>
        Array.isArray(value) ? value.length > 0 : false,
      ) ||
        (createdRange ? true : false) ||
        Object.values(tempRangeFilters.filters).some((value) => value !== 0),
    );
    settempRangeFilters({
      filters: {
        range_min: null,
        range_max: null,
      },
    });
  };

  if (!typeCongeList) return;
  return (
    <div
      className={`minthr-flex minthr-flex-items-center minthr-bg-light-gray1 minthr-border-rounded minthr-p-4 minthr-mobile-flex-wrap filters minthr-border-t ${className}`}
    >
      <DropdownFilter
        idPrefix="TypeConge"
        label={t('filter.typeConge')}
        options={
          typeCongeList.data.map((item) => ({
            text: item.text as string,
            value: item.value as string,
          })) || []
        }
        selectedOptions={tempFilters.filters.TypeConge}
        filters={tempFilters}
        setfilters={setTempFilters as Dispatch<SetStateAction<FiltersType>>}
        className="minthr-dropdown-checklist-left"
        buttonClassName="minthr-mobile-btn"
        labelClassName="minthr-mobile-text-truncate"
      />

      <div className="dropdown minthr-dropdown minthr-mr-2 minthr-mobile-mr-0 minthr-mobile-mb-2 minthr-mobile-px-2 minthr-mobile-w-50 minthr-icon-filter">
        <button
          type="button"
          className={`dropdown-toggle minthr-dropdown-btn minthr-btn-s minthr-border-rounded minthr-mobile-w-100 minthr-mobile-btn minthr-btn-filters ${createdRange?.[0] || createdRange?.[1] ? 'active filter-active show' : ''}  minthr-flex minthr-flex-items-center `}
        >
          <MinthrDateRangePicker
            startDate={createdRange?.[0] ?? moment()}
            endDate={createdRange?.[1] ?? moment()}
            label={t('filter.demandIn')}
            onChange={(startDate, endDate) => {
              setCreatedRange([startDate, endDate]);
            }}
            customView={(startDate, endDate) => (
              <>
                {' '}
                {createdRange?.[0] && startDate
                  ? startDate.format('L') + ' - ' + endDate?.format('L')
                  : t('filter.demandIn')}
              </>
            )}
            customViewClassName="minthr-mobile-text-truncate"
          />

          <a
            className="filter-close"
            onClick={(e) => {
              e.stopPropagation();
              setCreatedRange(null);
            }}
          >
            <img className="minthr-icon-gray" src="/icons/close.svg" alt="" />
          </a>
        </button>
      </div>

      <DropdownFilter
        idPrefix="status"
        label={t('filter.state')}
        options={statusOptions}
        selectedOptions={tempFilters.filters.status}
        filters={tempFilters}
        setfilters={setTempFilters as Dispatch<SetStateAction<FiltersType>>}
        className="minthr-dropdown-checklist-left"
      />
      <MinthrSlider
        idPrefix={['range_min', 'range_max']}
        label={t('filter.NrDays')}
        filters={tempRangeFilters}
        setfilters={settempRangeFilters}
        min={1}
        max={28}
        className="minthr-dropdown-checklist-right"
      />

      <div className="dropdown minthr-dropdown minthr-mr-2 minthr-mobile-mr-0 minthr-mobile-mb-2 minthr-mobile-px-2 minthr-mobile-w-50 minthr-icon-filter">
        <button
          type="button"
          className={`dropdown-toggle minthr-dropdown-btn minthr-btn-s minthr-border-rounded minthr-mobile-w-100 minthr-mobile-btn minthr-btn-filters  minthr-flex minthr-flex-items-center  ${selectedPeriod?.[0] || selectedPeriod?.[1] ? 'active filter-active show' : ''}   `}
        >
          <MinthrDateRangePicker
            startDate={selectedPeriod?.[0] ?? moment()}
            endDate={selectedPeriod?.[1] ?? moment()}
            label="Date Range"
            onChange={(startDate, endDate) => {
              setSelectedPeriod([startDate, endDate]);
            }}
            customView={(startDate, endDate) => (
              <>
                {' '}
                {selectedPeriod?.[0] && startDate
                  ? startDate.format('L') + ' - ' + endDate?.format('L')
                  : t('Filter.PeriodeVacation')}
              </>
            )}
            customViewClassName="minthr-mobile-text-truncate"
          />

          <a
            className="filter-close"
            onClick={(e) => {
              e.stopPropagation();
              setSelectedPeriod(null);
            }}
          >
            <img className="minthr-icon-gray" src="/icons/close.svg" alt="" />
          </a>
        </button>
      </div>

      <DropdownFilter
        idPrefix="society"
        label={t('Society')}
        options={
          societies?.data.map((item) => ({
            label: item.text || '',
            value: item.value || '',
            title: item.text || '',
          })) || []
        }
        selectedOptions={tempFilters.filters.society}
        filters={tempFilters}
        setfilters={setTempFilters as Dispatch<SetStateAction<FiltersType>>}
        className="minthr-dropdown-checklist-right"
      />
      <DropdownFilter
        idPrefix="site"
        label={t('Site')}
        options={
          (sites &&
            sites?.data.map((item) => ({
              label: item.text || '',
              value: item.value || '',
              title: item.text || '',
            }))) ||
          []
        }
        selectedOptions={tempFilters.filters.site}
        filters={tempFilters}
        setfilters={setTempFilters as Dispatch<SetStateAction<FiltersType>>}
        className="minthr-dropdown-checklist-left"
      />

      <DropdownFilter
        idPrefix="team"
        label={t('Service')}
        options={
          (sites &&
            teams?.data.map((item) => ({
              label: item.text || '',
              value: item.value || '',
              title: item.text || '',
            }))) ||
          []
        }
        selectedOptions={tempFilters.filters.site}
        filters={tempFilters}
        setfilters={setTempFilters as Dispatch<SetStateAction<FiltersType>>}
        className="minthr-dropdown-checklist-right"
      />

      <a
        onClick={handleApply}
        className="minthr-btn minthr-btn-s minthr-btn-primary minthr-mobile-m-0 text-s minthr-px-4 minthr-mobile-w-80 minthr-ml-auto minthr-mobile-mx-2"
      >
        {t('Apply')}
      </a>
      <a
        onClick={handleResetFilters}
        className="minthr-btn minthr-btn-s minthr-btn-outline minthr-btn-light-gray2 minthr-mobile-mr-2 p-0 minthr-ml-3 minthr-mobile-ml-auto"
      >
        <img
          className="minthr-icon-danger"
          src="/icons/delete.svg"
          alt="Reset Filters"
        />
      </a>
    </div>
  );
};

export default LeaveRequestFilter;
